import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

const AnioAduanaFromGroup = ({ iTouched, iError, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-importe', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='AÑO ADUANA' htmlFor='input-anioAduana' md={5} alignRightAt='md' />
      <Col md={7}>
        <Field name='anioAduana'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              id='input-anioAduana'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(AnioAduanaFromGroup)
